import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';

import iframeUrl from './urlGenerator';
import Iframe from './iframe';

export default function save( { attributes } ) {
	const {
		iframe_url,
		iframe_height,
		iframe_scrolling,
		iframe_allowfullscreen,
		lazyload,
		live,
		alignments,
		iframe_title,
		iframe_caption,
		iframe_id,
		iframe_class,
		iframe_style,
		iframe_name,
		iframe_sandbox,
	} = attributes;

	const videoUrl = iframeUrl( { iframe_url } );

	const aligned = alignments && `${ alignments }`.length ? alignments : 'center';
	const alignmentClass = `align${ aligned }`;

	const blockProps = useBlockProps.save( {
		className: alignmentClass.trim(),
	} );

	const iframeProps = {
		url: videoUrl,
		height: iframe_height,
		iframe_allowfullscreen,
		iframe_scrolling,
		iframe_title,
		iframe_id,
		iframe_class,
		iframe_style,
		iframe_name,
		iframe_sandbox,
		live,
		threshold: attributes.threshold,
	};

	const captionTrimmed =
		iframe_caption && String( iframe_caption ).trim()
			? String( iframe_caption ).trim()
			: '';

	const fallbackLabel =
		( iframe_title && String( iframe_title ).trim() ) ||
		captionTrimmed ||
		__( 'Open embedded content', 'wpxero-iframe' );

	return (
		<div { ...blockProps }>
			<figure className="wpxero-iframe-figure">
				<Iframe
					{ ...iframeProps }
					className={ lazyload ? 'lazy' : '' }
				/>
				{ captionTrimmed ? (
					<figcaption className="wpxero-iframe-caption">
						{ captionTrimmed }
					</figcaption>
				) : null }
				{ videoUrl ? (
					<noscript>
						<p className="wpxero-iframe-noscript">
							<a
								className="wpxero-iframe-fallback-link"
								href={ videoUrl }
								rel="noopener noreferrer"
								target="_blank"
							>
								{ fallbackLabel }
							</a>
						</p>
					</noscript>
				) : null }
			</figure>
		</div>
	);
}
